/* eslint camelcase: 0 */
import common from './common/ko_KR';
import confirmation from './confirmation/ko_KR';
import dapps from './dapps/ko_KR';
import header from './header/ko_KR';
import home from './home/ko_KR';
import footer from './footer/ko_KR';
import gettingStarted from './getting-started/ko_KR';
import privacyPolicy from './privacy-policy/ko_KR';
import termsAndConditions from './terms-of-conditions/ko_KR';
import createWallet from './create-wallet/ko_KR';
import accessWallet from './access-wallet/ko_KR';
import interfaceTranslations from './interface/ko_KR';
import team from './team/ko_KR';
import popover from './popover/ko_KR';
import withoutWallet from './without-wallet/ko_KR';
import errorsGlobal from './errors-global/ko_KR';
import trezorError from './errors-trezor/ko_KR';
import ledgerError from './errors-ledger/ko_KR';
import secalotError from './errors-secalot/ko_KR';
import keepkeyError from './errors-keepkey/ko_KR';
import bitboxError from './errors-bitbox/ko_KR';

const ko_KR = {
  common: common,
  confirmation: confirmation,
  dapps: dapps,
  header: header,
  home: home,
  footer: footer,
  gettingStarted: gettingStarted,
  privacyPol: privacyPolicy,
  termsOfConditions: termsAndConditions,
  team: team,
  accessWallet: accessWallet,
  createWallet: createWallet,
  interface: interfaceTranslations,
  popover: popover,
  withoutWallet: withoutWallet,
  errorsGlobal: errorsGlobal,
  trezorError: trezorError,
  ledgerError: ledgerError,
  secalotError: secalotError,
  keepkeyError: keepkeyError,
  bitboxError: bitboxError
};
export default ko_KR;
